<template>
  <div class="space-y-12 pt-16">
    <LargePicker
      v-for="(option, index) in options"
      :key="option.key"
      :index
      :label="option.label"
      :prefix
      :price="option.price"
      :selected="index === 0"
      :subLabel="option?.subLabel"
      @click="handleClick(option)"
    />
  </div>
</template>

<script setup lang="ts">
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'

import type { Prefixes as PickerPrefixes } from '~/scopes/product/components/CustomizationFunnel/components/LargePicker/LargePicker.types'
import LargePicker from '~/scopes/product/components/CustomizationFunnel/components/LargePicker/LargePicker.vue'

type MobilePlanOption = {
  key: string
  label: string
  subLabel?: string
  price?: string
}

defineProps<{
  options: MobilePlanOption[]
}>()

const emit = defineEmits<{
  select: []
}>()

const { trackClick } = useTracking()

const prefix = 'circle' as PickerPrefixes

const handleClick = (option: MobilePlanOption) => {
  trackClick({
    name: option.key,
    zone: 'mobile_plan_pickers',
  })

  emit('select')
}
</script>
